export const ADD_TASK_PRIORITIES = 'ADD_TASK_PRIORITIES'
export const ADD_TASK_PRIORITY = 'ADD_TASK_PRIORITY'
